import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthIdService {
  private authIdKey = 'auth_id';  // LocalStorage key

  constructor() { 
    const storedAuthId = localStorage.getItem(this.authIdKey);
    if (storedAuthId) {
      this.authId = storedAuthId;
    }
  }
  private authId: string | null = null;

  // Set the auth_id value
  setAuthId(authId: string): void {
    this.authId = authId;
    localStorage.setItem(this.authIdKey, authId); // Store in localStorage
  }

  // Get the auth_id value
  getAuthId(): string | null {
    return this.authId;
  }

  // Clear the auth_id if needed
  clearAuthId(): void {
    this.authId = null;
    localStorage.removeItem(this.authIdKey);  // Remove from localStorage
  }
}
